'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var http = require('./http-bb56b50d.js');
var history = require('./history-569c9f39.js');
Object.defineProperty(exports, 'ChannelType', {
  enumerable: true,
  get: function get() {
    return http.ChannelType;
  }
});
Object.defineProperty(exports, 'ENTRY_POINT_IN_URL', {
  enumerable: true,
  get: function get() {
    return http.ENTRY_POINT_IN_URL;
  }
});
Object.defineProperty(exports, 'ERROR_MESSAGE', {
  enumerable: true,
  get: function get() {
    return http.ERROR_MESSAGE;
  }
});
Object.defineProperty(exports, 'GRAY_RELEASE_CONFIG_ENTRY_POINT', {
  enumerable: true,
  get: function get() {
    return http.GRAY_RELEASE_CONFIG_ENTRY_POINT;
  }
});
Object.defineProperty(exports, 'MessageType', {
  enumerable: true,
  get: function get() {
    return http.MessageType;
  }
});
Object.defineProperty(exports, 'MsgFlow', {
  enumerable: true,
  get: function get() {
    return http.MsgFlow;
  }
});
exports.PrechatDetailItem = http.PrechatDetailItem;
Object.defineProperty(exports, 'SellerChannel', {
  enumerable: true,
  get: function get() {
    return http.SellerChannel;
  }
});
Object.defineProperty(exports, 'SessionStatus', {
  enumerable: true,
  get: function get() {
    return http.SessionStatus;
  }
});
Object.defineProperty(exports, 'SystemType', {
  enumerable: true,
  get: function get() {
    return http.SystemType;
  }
});
Object.defineProperty(exports, 'USER_QUEUE_TYPE', {
  enumerable: true,
  get: function get() {
    return http.USER_QUEUE_TYPE;
  }
});
Object.defineProperty(exports, 'UserEntryType', {
  enumerable: true,
  get: function get() {
    return http.UserEntryType;
  }
});
Object.defineProperty(exports, 'UserSessionChannelType', {
  enumerable: true,
  get: function get() {
    return http.UserSessionChannelType;
  }
});
Object.defineProperty(exports, 'UserSessionStatus', {
  enumerable: true,
  get: function get() {
    return http.UserSessionStatus;
  }
});
Object.defineProperty(exports, 'UserType', {
  enumerable: true,
  get: function get() {
    return http.UserType;
  }
});
Object.defineProperty(exports, 'HistoryApiMethod', {
  enumerable: true,
  get: function get() {
    return history.HistoryApiMethod;
  }
});
Object.defineProperty(exports, 'HistoryMsgType', {
  enumerable: true,
  get: function get() {
    return history.HistoryMsgType;
  }
});
Object.defineProperty(exports, 'InhouseHistoryType', {
  enumerable: true,
  get: function get() {
    return history.InhouseHistoryType;
  }
});
Object.defineProperty(exports, 'MessageSender', {
  enumerable: true,
  get: function get() {
    return history.MessageSender;
  }
});
Object.defineProperty(exports, 'NoMoreReason', {
  enumerable: true,
  get: function get() {
    return history.NoMoreReason;
  }
});
Object.defineProperty(exports, 'SfHistoryType', {
  enumerable: true,
  get: function get() {
    return history.SfHistoryType;
  }
});
Object.defineProperty(exports, 'TxBotMsgType', {
  enumerable: true,
  get: function get() {
    return history.TxBotMsgType;
  }
});